// import config from 'config';
import { authHeader } from "../_helpers";

export const webInquiryService = {
  sendWebInquiry
};

function sendWebInquiry(webInquiry) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(webInquiry),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/sendwebinquiry`, requestOptions)
    .then(_handleResponse)
    .then(_handleUserData);
}

function _handleResponse(response) {
  return response.text().then((text) => {
    const dataObject = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // window.location.reload(true);
      }

      const error = (dataObject && dataObject.message) || response.statusText;
      return Promise.reject(error);
    }

    // console.log('dataObject - ', dataObject);
    return dataObject;
  });
}

// this function getting data from response and returns them as an array
function _handleUserData(dataObject) {
  const data = dataObject ? dataObject.data : [];
  const dataArray = Array.isArray(data)
    ? data.map((item) => _transformData(item))
    : _transformData(data);

  return dataArray;
}

// this function transforms and returns a structure of user's data for further using
function _transformData(data) {
  return {
    id: data.id,
    firstName: data.first_name,
    lastName: data.last_name,
    email: data.email,
    phoneNumber: data.phone_number,
    message: data.message
  };
}
